/**
 * Does THIS database have `public.update_company_settings` yet?
 *
 * Deploy-order safety net: the app can reach a database before the migration
 * (20260929120000) does — dev/prod deploy the web bundle and the migration as
 * separate steps. `'unknown'` until first proven, then `'rpc'` (the function
 * exists → so do the audit triggers shipped in the same migration) or `'legacy'`
 * (missing → the pre-RPC direct-update path, with its client audit emits).
 *
 * Dependency-free ON PURPOSE (no supabase import): `resetBrandingDefaults()` —
 * the sign-out / tenant-switch reset — clears it, and that module must stay
 * pure. Per page load is the real lifetime; the reset just lets a session that
 * saw 'legacy' re-probe after the migration lands.
 */
let capability = 'unknown';

export const getCompanySettingsRpcCapability = () => capability;
export const setCompanySettingsRpcCapability = (next) => { capability = next; };
export const resetCompanySettingsRpcCapability = () => { capability = 'unknown'; };

/**
 * "The function is not deployed here": PostgREST PGRST202 (not in the schema
 * cache), Postgres 42883 (undefined_function), or a bare HTTP 404 for the rpc.
 * Everything else — NOT_AUTHORIZED, MFA_REQUIRED, validation, network — is a
 * REAL failure and must never trigger the legacy fallback.
 */
export const isMissingRpcError = (error, status) => {
  if (!error) return false;
  return error.code === 'PGRST202' || error.code === '42883' || status === 404;
};
